import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function clientsReducer(state = initialState.clients, action) {
  switch (action.type) {
    case types.LOAD_CLIENTS_SUCCESS:
      return {...action.clients, saveError: initialState.clients.saveError, saveInfo: initialState.clients.saveInfo};
    case types.SAVE_CLIENT_SUCCESS: {
      let clientToAdd = action.client;
      let newState = [...state.items].map((x) => {
        let returnVal = {...x};
        if (returnVal.id == clientToAdd.id) {
          return {...clientToAdd};
        }
        return returnVal;
      });

      if (!_.some(state.items, y => y.id == clientToAdd.id)) {
        newState = [...newState, clientToAdd];
      }
      return {
        ...state,
        items: _.sortBy(newState, x => x.companyName.toLowerCase()),
        saveError: initialState.clients.saveError,
        saveInfo: {...state.saveInfo, saved: true, saving: false, isNew: action.isNew, client: clientToAdd},
      };
    }
    case types.DELETE_CLIENT_SUCCESS:
      return {
        ...state,
        items: [...state.items.filter(x => x.id != action.client.id)],
        saveError: initialState.clients.saveError,
        saveInfo: {...state.saveInfo, saved: true, saving: false,},
      };
    case types.SAVE_CLIENT_ERROR:
      return {
        ...state,
        saveError: action.saveError,
        saveInfo: {...state.saveInfo, saved: true, saving: false},
      };
    case types.SAVE_CLIENT_SAVING:
      return {...state, saveInfo: {...action.saveInfo}};
    default:
      return state;
  }
}
